export const GENERIC_ERROR__DETAILS_IN_CONSOLE = {
  type: "error",
  text: "Wystąpił błąd",
  details: "Więcej informacji w konsoli",
} as const
